import React from "react";

const SmsHotelTicket = () => {
  return (
    <div>
      <h1>SmsHotelTicket</h1>
    </div>
  );
};

export default SmsHotelTicket;
